module.exports = __webpack_public_path__ + "static/media/SENIB.50a1265a.png";